<script setup lang="ts">
import { useToastStore } from "@/stores/toast";

const toastStore = useToastStore();

const alertClass = (kind: string) =>
  kind === "success"
    ? "alert-success"
    : kind === "info"
      ? "alert-info"
      : "alert-error";
</script>

<template>
  <!-- Global notification host. Mounted once in App.vue; fed by apiClient's
       response interceptor for any error a view doesn't handle itself. -->
  <div
    class="toast toast-end toast-bottom z-50 max-w-md"
    data-testid="toast-host"
  >
    <div
      v-for="toast in toastStore.toasts"
      :key="toast.id"
      role="alert"
      class="alert shadow-lg"
      :class="alertClass(toast.kind)"
      data-testid="toast"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
        />
      </svg>
      <span class="text-sm">{{ toast.message }}</span>
      <button
        class="btn btn-ghost btn-xs"
        aria-label="Tutup"
        @click="toastStore.dismiss(toast.id)"
      >
        ✕
      </button>
    </div>
  </div>
</template>
